import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Domain\Billing\Presentation\Http\Controllers\OrgManualSubscriptionController::store
* @see app/Domain/Billing/Presentation/Http/Controllers/OrgManualSubscriptionController.php:12
* @route 'https://org.proexpert.app/org/customers/{user}/businesses/{business}/subscription'
*/
export const store = (args: { user: string | number, business: string | number } | [user: string | number, business: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/customers/{user}/businesses/{business}/subscription',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Billing\Presentation\Http\Controllers\OrgManualSubscriptionController::store
* @see app/Domain/Billing/Presentation/Http/Controllers/OrgManualSubscriptionController.php:12
* @route 'https://org.proexpert.app/org/customers/{user}/businesses/{business}/subscription'
*/
store.url = (args: { user: string | number, business: string | number } | [user: string | number, business: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            user: args[0],
            business: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: args.user,
        business: args.business,
    }

    return store.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace('{business}', parsedArgs.business.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Billing\Presentation\Http\Controllers\OrgManualSubscriptionController::store
* @see app/Domain/Billing/Presentation/Http/Controllers/OrgManualSubscriptionController.php:12
* @route 'https://org.proexpert.app/org/customers/{user}/businesses/{business}/subscription'
*/
store.post = (args: { user: string | number, business: string | number } | [user: string | number, business: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Billing\Presentation\Http\Controllers\OrgManualSubscriptionController::store
* @see app/Domain/Billing/Presentation/Http/Controllers/OrgManualSubscriptionController.php:12
* @route 'https://org.proexpert.app/org/customers/{user}/businesses/{business}/subscription'
*/
const storeForm = (args: { user: string | number, business: string | number } | [user: string | number, business: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Billing\Presentation\Http\Controllers\OrgManualSubscriptionController::store
* @see app/Domain/Billing/Presentation/Http/Controllers/OrgManualSubscriptionController.php:12
* @route 'https://org.proexpert.app/org/customers/{user}/businesses/{business}/subscription'
*/
storeForm.post = (args: { user: string | number, business: string | number } | [user: string | number, business: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

const subscription = {
    store: Object.assign(store, store),
}

export default subscription